//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('subscriptionGrid', {
//        templateUrl: 'views/components/views/subscriptionGrid/subscriptionGrid.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'subscriptionGridService', 'logisticService', 'ttGridFactory', 'rememberService', function ($stateParams, stateService, utilityService, subscriptionGridService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let variableNames = {
//                is_active: ''
//            };

//            vm.model = {
//                companyButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('businessco_no') }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListIsActive: [],
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_subscriptiongrid.grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'subscriptiongrid_new',
//                    text: 'subscriptiongrid_new',
//                    func: () => {
//                        logisticService.getNextCounterNumber({ counter_id: 'subscription_keyno' }).then(function (response) {
//                            stateService.go('subscription', { subscription_keyno: response[0].nextnumber });
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await subscriptionGridService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadIsActive() {
//                vm.model.selectListIsActive = await subscriptionGridService.listIsActive();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies({ add_all: '1' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3208,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'is_active':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'businessco_no':
//                        vm.model.setting.businessco_no = '99999';

//                        if (vm.model.setting.businessco_no === '99999') loadGrid();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        if (vm.model.setting.businessco_no !== '99999') loadGrid();
//                        break;
//                    case 'is_active':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.is_active) !== true) return;

//                        vm.model.setting.is_active = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.is_active) !== true) return;

//                        rememberFunc('is_active');
//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//            	await loadSetting();
//                loadCompanies();
//                loadIsActive();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
